export const PromoBadge = () => {
  return (
    <svg
      className="promo-badge-icon"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7008 1.20001C12.7258 1.20002 13.7088 1.60728 14.4336 2.33204L22.1703 10.0688C23.6796 11.578 23.6796 14.0251 22.1703 15.5344L16.0344 21.6703C14.5251 23.1796 12.078 23.1796 10.5688 21.6703L2.83204 13.9336C2.10728 13.2088 1.70002 12.2258 1.70001 11.2008V3.13243C1.70001 2.06522 2.56522 1.20001 3.63243 1.20001H11.7008ZM8.30001 6.00001C7.3059 6.00001 6.50001 6.8059 6.50001 7.80001C6.50001 8.79413 7.3059 9.60001 8.30001 9.60001C9.29413 9.60001 10.1 8.79413 10.1 7.80001C10.1 6.8059 9.29413 6.00001 8.30001 6.00001Z"
        fill="white"
      />
    </svg>
  )
}
